import { useMutation } from "@tanstack/react-query";
import { authApi } from "../api/authApi";

export function useResetPasswordConfirmMutation() {
  return useMutation({ mutationFn: authApi.confirmPasswordReset });
}
